// A horizontal drag/scroll strip backed by Embla (the AI photo editor's recent-photos carousel, shared with the Studio Editor).
// `getEmblaApi` hands the Embla API to the caller (for ‹ › buttons via scrollPrev/scrollNext).
import { useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';

const Carousel = ({ children, getEmblaApi, dragFree, slideGap, align, withControls, loop, style, styles: cStyles }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    dragFree: dragFree !== false,
    align: align || 'start',
    loop: !!loop,
    containScroll: 'trimSnaps',
  });
  useEffect(() => {
    if (!emblaApi || !getEmblaApi) return;
    getEmblaApi(emblaApi);
  }, [emblaApi]);
  return (
    <div ref={emblaRef} style={{ overflow: 'hidden', cursor: 'grab', ...cStyles?.viewport, ...style }}>
      <div style={{ display: 'flex', gap: slideGap ?? 12 }}>
        {children}
      </div>
    </div>
  );
};
Carousel.Slide = ({ children, style }) => <div style={{ minWidth: 0, flexShrink: 0, ...style }}>{children}</div>;

export default Carousel;
